import { call, put, takeLatest } from 'redux-saga/effects';
import { apiClient } from '../../utils/axios';
import {
  fetchOrgFailure,
  fetchOrgRequest,
  fetchOrgSettingsFailure,
  fetchOrgSettingsRequest,
  fetchOrgSettingsSuccess,
  fetchOrgSuccess,
  updateOrgSettingsFailure,
  updateOrgSettingsRequest,
  updateOrgSettingsSuccess,
} from './orgSlice';
import { showSnackbar } from '../snackbarSlice';

function* fetchOrg(action) {
  try {
    const response = yield call(apiClient.get, `/organization`);
    yield put(fetchOrgSuccess(response.data));
  } catch (error) {
    yield put(fetchOrgFailure(error.response?.data?.errors?.message || 'Login failed'));
  }
}

function* fetchOrgSettingsSaga() {
  try {
    const response = yield call(apiClient.get, `/organizations/settings`);
    yield put(fetchOrgSettingsSuccess(response.data));
  } catch (error) {
    yield put(fetchOrgSettingsFailure(error.response?.data?.message || 'Failed to fetch settings'));
  }
}

function* updateOrgSettingsSaga(action) {
  try {
    const { updates } = action.payload;
    const response = yield call(apiClient.patch, `/organizations/settings/email`, updates);
    yield put(updateOrgSettingsSuccess(response.data));
    yield put(showSnackbar({ message: 'Settings updated successfully!', severity: 'success' }));
  } catch (error) {
    yield put(updateOrgSettingsFailure(error.response?.data?.message || 'Failed to update settings'));
    yield put(showSnackbar({ message: error.response?.data?.message, severity: 'error' }));
  }
}

export default function* orgSaga() {
  yield takeLatest(fetchOrgRequest.type, fetchOrg);
  yield takeLatest(fetchOrgSettingsRequest.type, fetchOrgSettingsSaga);
  yield takeLatest(updateOrgSettingsRequest.type, updateOrgSettingsSaga);
}
